module.exports = __webpack_public_path__ + "img/xunlei.5e3c54b4.png";